export const decorateOrderId = (orderId: number): string => `SPL${orderId}`
